import { useMemo,useRef } from "react";
import { AgTableServer } from "app/shared/AgTable";
import PageHeader from "app/shared/PageHeader";
import textLinkRenderer from "./textLinkRenderer";


const AssetLinkCellRenderer = (params) => {
  const url = params?.value;
  if (!url || typeof url !== "string") return "-";

  return (
    <a href={url} target="_blank" rel="noreferrer">
      Open
    </a>
  );
};

const HotelReport = () => {
 const gridRef = useRef();

  const columnDefs = useMemo(
    () => [
    {
        headerName: "Manual",
        cellRenderer: textLinkRenderer,
        field: "_id",
        noConfigCheck: true,
        minWidth: 240,
        // cellRendererParams: {
        //   handleClick: togglePdfSidePanel,
        // }
      },
        {
            headerName: "AI Parsed Data",
            children: [
              {
                headerName: "Document Type",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.document_type,
                minWidth: 180,
              },
              {
                headerName: "Hotel Name",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.hotel_name,
                minWidth: 200,
              },
              {
                headerName: "Client Name",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.client_name,
                minWidth: 200,
              },
              {
                headerName: "Invoice No",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.invoice_number,
                minWidth: 160,
              },
              {
                headerName: "Invoice Date",
                valueGetter: (p) => {
                  const d = p.data?.AI_parsed_data?.parsed_data?.invoice_date;
                  return d ? new Date(d).toLocaleDateString("en-IN") : "";
                },
                minWidth: 180,
              },
              {
                headerName: "Subtotal",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.subtotal,
                filter: "agNumberColumnFilter",
                minWidth: 150,
              },
              {
                headerName: "GST Amount",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.gst_amount,
                filter: "agNumberColumnFilter",
                minWidth: 150,
              },
              {
                headerName: "Invoice Amount",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.invoice_amount,
                filter: "agNumberColumnFilter",
                minWidth: 170,
              },
              {
                headerName: "Hotel GSTIN",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.hotel_gstin,
                minWidth: 180,
              },
              {
                headerName: "Guest GSTIN",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.guest_gstin,
                minWidth: 180,
              },
              {
                headerName: "Hotel City",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.hotel_city,
                minWidth: 150,
              },
              {
                headerName: "Hotel State",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.hotel_state,
                minWidth: 150,
              },
              {
                headerName: "Check-in",
                valueGetter: (p) => {
                  const d = p.data?.AI_parsed_data?.parsed_data?.checkin_date;
                  return d ? new Date(d).toLocaleDateString("en-IN") : "";
                },
                minWidth: 160,
              },
              {
                headerName: "Check-out",
                valueGetter: (p) => {
                  const d = p.data?.AI_parsed_data?.parsed_data?.checkout_date;
                  return d ? new Date(d).toLocaleDateString("en-IN") : "";
                },
                minWidth: 160,
              },
              {
                headerName: "CGST",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.cgst_amount,
                filter: "agNumberColumnFilter",
                minWidth: 120,
              },
              {
                headerName: "SGST",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.sgst_amount,
                filter: "agNumberColumnFilter",
                minWidth: 120,
              },
              {
                headerName: "IGST",
                valueGetter: (p) => p.data?.AI_parsed_data?.parsed_data?.igst_amount,
                filter: "agNumberColumnFilter",
                minWidth: 120,
              },
              {
                headerName: "State Code Match",
                valueGetter: (p) =>
                  p.data?.AI_parsed_data?.parsed_data?.state_code_match ? "Yes" : "No",
                minWidth: 180,
              },
            ],
          }
    ],
    []
  );

  return (
   <div style={{ height: "100%", width: "100%" }}>
      <PageHeader
        title="Hotel Report"
        showWorkspaceDropdown={false}
      />
      <div style={{ height: "100%", width: "100%" }}>
       <AgTableServer
        ref={gridRef}
        columnDefs={columnDefs}
        endpoint="https://stage-apiplatform.finkraftai.com/api/finalytics/tables/data/preview_test"//need change preview_test to parserTable
        serverPayload={{ database: "Hotel_Product", table: "Hotel_Parser_system_data" ,endRow:100}}
        enablePDFViewer
        pdfV2
        groupPanel
       />
      </div>
   </div>
  );
};

export default HotelReport;
